import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const selfEsteemChild: BlogMetaData = {
  title: '子どもの自己肯定感を高める声かけ｜モンテッソーリ流の接し方と注意点',
  description:
    '子どもの自己肯定感はどう育つ？年齢別の高め方や避けたいNG声かけ、家庭で今日から試せる具体的な接し方の工夫を、モンテッソーリ教育の視点からやさしく丁寧に解説します。',
  thumbnailUrl: '/img/blog-self-esteem-child.webp',
  filePath: buildBlogFilePath('self-esteem-child'),
  category: BLOG_CATEGORY.PARENTING,
};
